/*
 * Auto-generated Zod schemas from OpenAPI
 * Regenerate by running: npx ts-node scripts/generateRoutesAndSchemas.ts
 */
import { z } from 'zod';

// GET /api/:version/hello/:name
export const HelloRegistry = {
  requestSchema: z.object({
    params: z.object({
      name: z.string(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      name: z.string(),
      timestamp: z.coerce.number(),
    }),
  }),
};

// Error response schema (500) for GET /api/:version/hello/:name
export const HelloError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type HelloError500 = z.infer<typeof HelloError500Schema>;

// GET /api/:version/docs/conex/openapi
export const GetConexApiSpecRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      openapi: z.string(),
      info: z.object({
        title: z.string(),
        version: z.string(),
        description: z.string().nullable(),
      }).catchall(z.unknown()),
      paths: z.object({}).catchall(z.unknown()),
      servers: z.array(z.object({}).catchall(z.unknown())).nullable(),
      tags: z.array(z.object({}).catchall(z.unknown())).nullable(),
      components: z.object({}).catchall(z.unknown()).nullable(),
      security: z.array(z.object({}).catchall(z.unknown())).nullable(),
    }).catchall(z.unknown()),
  }),
};

// Error response schema (500) for GET /api/:version/docs/conex/openapi
export const GetConexApiSpecError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetConexApiSpecError500 = z.infer<typeof GetConexApiSpecError500Schema>;

// POST /api/:version/uniq/users
export const UpsertUserRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      userNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      firstName: z.string().min(1).max(20),
      lastName: z.string().min(1).max(20),
      userName: z.string().min(3).max(30),
      emailAddress: z.string().max(254).email(),
      countryCode: z.string().min(1).max(3).nullish(),
      mobileNumber: z.string().min(10).max(10).nullish(),
      profilePicture: z.string().max(2048).nullish(),
      userStatus: z.enum(["active", "suspended"]).nullish(),
      tenants: z.array(z.enum(["conex", "farmgrid"])).min(1),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string(),
        lastName: z.string(),
        userName: z.string(),
        emailAddress: z.string(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        profilePicture: z.string().nullable(),
        userStatus: z.string(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        tenants: z.array(z.enum(["conex", "farmgrid"])).nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/uniq/users
export const GetUsersRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      users: z.array(z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string().min(1).max(20),
        lastName: z.string().min(1).max(20),
        emailAddress: z.string().email().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        profilePicture: z.string().nullable(),
        userStatus: z.enum(["active", "suspended", "archived"]).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        organizations: z.array(z.object({
          orgNumber: z.coerce.number().nullable(),
          name: z.string().nullable(),
        })).nullable(),
        jobRoles: z.array(z.object({
          jobRoleNumber: z.coerce.number().nullable(),
          jobRoleName: z.string().nullable(),
        })).nullable(),
        tenants: z.array(z.enum(["conex", "farmgrid"])),
      })),
      total: z.coerce.number().gte(0).nullable(),
    }),
  }),
};

// GET /api/:version/uniq/users/:userNumber
export const GetUserByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string().min(1).max(20),
        lastName: z.string().min(1).max(20),
        userName: z.string().min(3).max(30).nullable(),
        emailAddress: z.string().email().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        profilePicture: z.string().nullable(),
        userStatus: z.enum(["active", "suspended", "archived"]).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        organizations: z.array(z.object({
          orgNumber: z.coerce.number().nullable(),
          name: z.string().nullable(),
        })).nullable(),
        jobRoles: z.array(z.object({
          jobRoleNumber: z.coerce.number().nullable(),
          jobRoleName: z.string().nullable(),
        })).nullable(),
        tenants: z.array(z.enum(["conex", "farmgrid"])),
      }),
    }),
  }),
};

// Error response schema (404) for GET /api/:version/uniq/users/:userNumber
export const GetUserByNumberError404Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetUserByNumberError404 = z.infer<typeof GetUserByNumberError404Schema>;

// DELETE /api/:version/uniq/users/:userNumber
export const ArchiveUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean().nullable(),
    }),
  }),
};

// PATCH /api/:version/uniq/users/:userNumber/status
export const SetUserStatusRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      status: z.enum(["active", "inactive"]),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        userStatus: z.enum(["active", "suspended", "archived"]),
      }),
    }),
  }),
};

// GET /api/:version/uniq/users/:userNumber/profile-picture
export const FetchUserProfilePictureRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      profilePictureUrl: z.string().url(),
    }),
  }),
};

// GET /api/:version/uniq/users/:userNumber/timeline
export const GetUserEventTimelineRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      events: z.array(z.object({
        eventId: z.string(),
        eventType: z.string(),
        eventDescription: z.string().nullable(),
        timestamp: z.coerce.number(),
        metadata: z.object({}).catchall(z.unknown()).nullable(),
      })),
      total: z.coerce.number().gte(0),
      limit: z.coerce.number().gte(1).nullable(),
      offset: z.coerce.number().gte(0).nullable(),
    }),
  }),
};

// GET /api/:version/uniq/user/email/:emailId
export const GetUserByEmailRegistry = {
  requestSchema: z.object({
    params: z.object({
      emailId: z.string().email(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string().min(1).max(20),
        lastName: z.string().min(1).max(20),
        userName: z.string().min(3).max(30).nullable(),
        emailAddress: z.string().email().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        profilePicture: z.string().nullable(),
        userStatus: z.enum(["active", "suspended", "archived"]).nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        organizations: z.array(z.object({
          orgNumber: z.coerce.number().nullable(),
          name: z.string().nullable(),
        })).nullable(),
        jobRoles: z.array(z.object({
          jobRoleNumber: z.coerce.number().nullable(),
          jobRoleName: z.string().nullable(),
        })).nullable(),
        tenants: z.array(z.enum(["conex", "farmgrid"])),
      }),
    }),
  }),
};

// Error response schema (404) for GET /api/:version/uniq/user/email/:emailId
export const GetUserByEmailError404Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetUserByEmailError404 = z.infer<typeof GetUserByEmailError404Schema>;

// POST /api/:version/resendInvitation
export const ResendUserInvitationRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      inviteeNumber: z.coerce.number(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitation: z.object({
        inviteeNumber: z.coerce.number().nullable(),
        emailId: z.string().email().nullable(),
        status: z.string().nullable(),
      }),
    }),
  }),
};

// GET /api/:version/getHumanUserRoles
export const GetHumanUserRolesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      roles: z.array(z.object({
        id: z.string(),
        roleNumber: z.coerce.number(),
        roleName: z.string(),
        owner: z.array(z.coerce.number()).nullable(),
        accessPolicies: z.array(z.object({})).nullable(),
      })),
    }),
  }),
};

// POST /api/:version/uniq/auth/token
export const GenerateEntraOauthTokenRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    token_type: z.string().min(5).max(20),
    expires_in: z.coerce.number().gte(1),
    ext_expires_in: z.coerce.number().gte(1),
    access_token: z.string().min(16).max(4096),
  }),
};

// POST /api/:version/uniq/auth/login
export const LoginRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      token: z.string().min(1).max(8192),
      expiresAt: z.coerce.number().gte(1),
      profile: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string().min(1),
        lastName: z.string().min(1),
        emailAddress: z.string().email(),
        userName: z.string().min(1),
        profilePicture: z.string().nullable(),
        userStatus: z.string(),
        userRoles: z.array(z.string()),
        organisation: z.object({
          orgNumber: z.coerce.number().gte(1),
          orgName: z.string().min(1),
        }).nullable(),
        permissions: z.array(z.string()),
      }),
    }),
  }),
};

// Error response schema (401) for POST /api/:version/uniq/auth/login
export const LoginError401Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type LoginError401 = z.infer<typeof LoginError401Schema>;

// Error response schema (403) for POST /api/:version/uniq/auth/login
export const LoginError403Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type LoginError403 = z.infer<typeof LoginError403Schema>;

// Error response schema (500) for POST /api/:version/uniq/auth/login
export const LoginError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type LoginError500 = z.infer<typeof LoginError500Schema>;

// POST /api/:version/uniq/farmgrid-user/auth/login
export const FarmgridUserLoginRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      profile: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string().min(1),
        lastName: z.string().min(1),
        emailAddress: z.string().email(),
        userName: z.string().min(1),
        profilePicture: z.string().nullable(),
        redirectUrl: z.string().nullable(),
        userStatus: z.string(),
        userRoles: z.array(z.string()),
        organisation: z.object({
          orgNumber: z.coerce.number().gte(1),
          orgName: z.string().min(1),
        }).nullable(),
        permissions: z.array(z.string()),
      }),
    }),
  }),
};

// Error response schema (401) for POST /api/:version/uniq/farmgrid-user/auth/login
export const FarmgridUserLoginError401Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type FarmgridUserLoginError401 = z.infer<typeof FarmgridUserLoginError401Schema>;

// Error response schema (403) for POST /api/:version/uniq/farmgrid-user/auth/login
export const FarmgridUserLoginError403Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type FarmgridUserLoginError403 = z.infer<typeof FarmgridUserLoginError403Schema>;

// Error response schema (500) for POST /api/:version/uniq/farmgrid-user/auth/login
export const FarmgridUserLoginError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type FarmgridUserLoginError500 = z.infer<typeof FarmgridUserLoginError500Schema>;

// POST /api/:version/uniq/auth/silent-refresh
export const SilentRefreshRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      profile: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string().min(1),
        lastName: z.string().min(1),
        emailAddress: z.string().email(),
        userName: z.string().min(1),
        profilePicture: z.string().nullable(),
        userStatus: z.string(),
        userRoles: z.array(z.string()),
        organisation: z.object({
          orgNumber: z.coerce.number().gte(1),
          orgName: z.string().min(1),
        }).nullable(),
        permissions: z.array(z.string()),
      }),
    }),
  }),
};

// Error response schema (401) for POST /api/:version/uniq/auth/silent-refresh
export const SilentRefreshError401Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type SilentRefreshError401 = z.infer<typeof SilentRefreshError401Schema>;

// Error response schema (404) for POST /api/:version/uniq/auth/silent-refresh
export const SilentRefreshError404Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type SilentRefreshError404 = z.infer<typeof SilentRefreshError404Schema>;

// Error response schema (500) for POST /api/:version/uniq/auth/silent-refresh
export const SilentRefreshError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type SilentRefreshError500 = z.infer<typeof SilentRefreshError500Schema>;

// GET /api/:version/uniq/auth/me
export const GetCurrentUserRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      profile: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        firstName: z.string().min(1),
        lastName: z.string().min(1),
        emailAddress: z.string().email(),
        userName: z.string().min(1),
        profilePicture: z.string().nullable(),
        userStatus: z.string(),
        userRoles: z.array(z.string()),
        organisation: z.object({
          orgNumber: z.coerce.number().gte(1),
          orgName: z.string().min(1),
        }).nullable(),
        permissions: z.array(z.string()),
      }),
    }),
  }),
};

// Error response schema (401) for GET /api/:version/uniq/auth/me
export const GetCurrentUserError401Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetCurrentUserError401 = z.infer<typeof GetCurrentUserError401Schema>;

// Error response schema (500) for GET /api/:version/uniq/auth/me
export const GetCurrentUserError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetCurrentUserError500 = z.infer<typeof GetCurrentUserError500Schema>;

// POST /api/:version/uniq/auth/logout
export const LogoutRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      loggedOut: z.boolean(),
    }),
  }),
};

// Error response schema (401) for POST /api/:version/uniq/auth/logout
export const LogoutError401Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type LogoutError401 = z.infer<typeof LogoutError401Schema>;

// Error response schema (404) for POST /api/:version/uniq/auth/logout
export const LogoutError404Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type LogoutError404 = z.infer<typeof LogoutError404Schema>;

// Error response schema (500) for POST /api/:version/uniq/auth/logout
export const LogoutError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type LogoutError500 = z.infer<typeof LogoutError500Schema>;

// GET /api/:version/uniq/auth/session/validate
export const ValidateSessionRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      isValid: z.boolean(),
      remainingTtlSeconds: z.coerce.number().gte(0),
      expiresAt: z.coerce.number().gte(1),
    }),
  }),
};

// Error response schema (401) for GET /api/:version/uniq/auth/session/validate
export const ValidateSessionError401Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type ValidateSessionError401 = z.infer<typeof ValidateSessionError401Schema>;

// Error response schema (500) for GET /api/:version/uniq/auth/session/validate
export const ValidateSessionError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type ValidateSessionError500 = z.infer<typeof ValidateSessionError500Schema>;

// POST /api/:version/uniq/auth/aws/temp-credentials
export const GetAwsTempCredentialsRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      awsResource: z.enum(["s3", "ses"]),
      workloadUri: z.string().nullish(),
      bucketName: z.string().nullish(),
      operations: z.array(z.object({
        objectKey: z.string().nullish(),
        action: z.enum(["getObject", "putObject", "renameObject", "createBucket", "provisionBucketFolders", "listFolders"]).nullish(),
      })).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      accessKeyId: z.string(),
      secretAccessKey: z.string(),
      sessionToken: z.string(),
      region: z.string(),
      expiration: z.coerce.number(),
    }),
  }),
};

// Error response schema (400) for POST /api/:version/uniq/auth/aws/temp-credentials
export const GetAwsTempCredentialsError400Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetAwsTempCredentialsError400 = z.infer<typeof GetAwsTempCredentialsError400Schema>;

// Error response schema (500) for POST /api/:version/uniq/auth/aws/temp-credentials
export const GetAwsTempCredentialsError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetAwsTempCredentialsError500 = z.infer<typeof GetAwsTempCredentialsError500Schema>;

// POST /api/:version/uniq/auth/aws/presigned-url
export const GetAwsPresignedUrlRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      bucketName: z.string(),
      userNumber: z.coerce.number(),
      orgNumber: z.coerce.number(),
      farmProfileNumber: z.coerce.number(),
      operations: z.array(z.object({
        tokenOperation: z.enum(["list_objects_v2", "get_object", "put_object"]),
        s3Uris: z.array(z.string()).min(1),
      })).min(1),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      results: z.array(z.object({
        s3Uri: z.string(),
        tokenOperation: z.enum(["list_objects_v2", "get_object", "put_object"]),
        url: z.string(),
        expiresIn: z.coerce.number(),
      })),
    }),
  }),
};

// Error response schema (400) for POST /api/:version/uniq/auth/aws/presigned-url
export const GetAwsPresignedUrlError400Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetAwsPresignedUrlError400 = z.infer<typeof GetAwsPresignedUrlError400Schema>;

// Error response schema (500) for POST /api/:version/uniq/auth/aws/presigned-url
export const GetAwsPresignedUrlError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type GetAwsPresignedUrlError500 = z.infer<typeof GetAwsPresignedUrlError500Schema>;

// POST /api/:version/ink/contracts
export const UpsertContractRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      contractNumber: z.coerce.number().nullish(),
      orgNumberList: z.array(z.coerce.number()),
      contractType: z.enum(["Purchase Order", "Sales Order", "Lease Agreement", "MSA", "MNDA", "Purchase Invoice", "Sales Invoice", "Participation Agreement"]),
      executionDate: z.coerce.number().nullish(),
      term: z.string().nullish(),
      expirationDate: z.coerce.number().nullish(),
      noticeDate: z.coerce.number().nullish(),
      reminderPeriod: z.coerce.number().nullish(),
      comments: z.string().nullish(),
      contractOwner: z.coerce.number().nullish(),
      fileLocation: z.string().nullish(),
      contractStatus: z.enum(["active", "voided", "archived"]).nullish(),
      archiveDate: z.string().nullish(),
      createdAt: z.coerce.number().nullish(),
      updatedAt: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      contract: z.object({
        contractNumber: z.coerce.number(),
        orgNumberList: z.array(z.coerce.number()),
        contractType: z.enum(["Purchase Order", "Sales Order", "Lease Agreement", "MSA", "MNDA", "Purchase Invoice", "Sales Invoice", "Participation Agreement"]),
        executionDate: z.coerce.number().nullable(),
        term: z.string().nullable(),
        expirationDate: z.coerce.number().nullable(),
        noticeDate: z.coerce.number().nullable(),
        reminderPeriod: z.coerce.number().nullable(),
        comments: z.string().nullable(),
        contractOwner: z.coerce.number().nullable(),
        fileLocation: z.string().nullable(),
        contractStatus: z.enum(["active", "voided", "archived"]).nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/ink/contracts/:contractNumber
export const GetContractByContractNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      contractNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      contract: z.object({
        contractNumber: z.coerce.number(),
        orgNumberList: z.array(z.coerce.number()),
        contractType: z.enum(["Purchase Order", "Sales Order", "Lease Agreement", "MSA", "MNDA", "Purchase Invoice", "Sales Invoice", "Participation Agreement"]),
        executionDate: z.coerce.number().nullable(),
        term: z.string().nullable(),
        expirationDate: z.coerce.number().nullable(),
        noticeDate: z.coerce.number().nullable(),
        reminderPeriod: z.coerce.number().nullable(),
        comments: z.string().nullable(),
        contractOwner: z.coerce.number().nullable(),
        fileLocation: z.string().nullable(),
        contractStatus: z.enum(["active", "voided", "archived"]).nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/ink/contracts/:contractNumber
export const ArchiveContractRegistry = {
  requestSchema: z.object({
    params: z.object({
      contractNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/mint/organizations
export const UpsertOrganizationRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      orgNumber: z.coerce.number().nullish(),
      orgCode: z.string(),
      name: z.string(),
      website: z.string().url().nullish(),
      country: z.string(),
      emailId: z.string().email(),
      type: z.string().nullish(),
      role: z.string().nullish(),
      accountManagerId: z.string().nullish(),
      phone: z.string().nullish(),
      taxId: z.string().nullish(),
      employeeCount: z.coerce.number().nullish(),
    }).strict(),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      organization: z.object({
        orgNumber: z.coerce.number(),
        orgCode: z.string(),
        name: z.string(),
        website: z.string().nullable(),
        country: z.string(),
        emailId: z.string(),
        archiveDate: z.coerce.number().nullable(),
        type: z.string().nullable(),
        role: z.string().nullable(),
        accountManagerId: z.string().nullable(),
        phone: z.string().nullable(),
        taxId: z.string().nullable(),
        employeeCount: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/mint/organizations
export const GetOrganizationsRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      organizations: z.array(z.object({
        orgNumber: z.coerce.number(),
        orgCode: z.string(),
        name: z.string(),
        website: z.string().nullable(),
        country: z.string(),
        emailId: z.string(),
        archiveDate: z.coerce.number().nullable(),
        type: z.string().nullable(),
        role: z.string().nullable(),
        accountManagerId: z.string().nullable(),
        phone: z.string().nullable(),
        taxId: z.string().nullable(),
        employeeCount: z.coerce.number().nullable(),
      })),
      total: z.coerce.number().gte(0).nullable(),
    }),
  }),
};

// POST /api/:version/mint/organizations/resolve
export const ResolveOrganizationsRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      orgIds: z.array(z.string().uuid()).max(500).nullish(),
      orgNumbers: z.array(z.coerce.number()).max(500).nullish(),
      userNumbers: z.array(z.coerce.number()).max(500).nullish(),
      dataFeature: z.string().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      organizations: z.array(z.object({
        orgId: z.string().uuid(),
        orgNumber: z.coerce.number(),
        attributes: z.object({}).catchall(z.object({}).catchall(z.unknown())),
      })),
      userOrganizations: z.array(z.object({
        userNumber: z.coerce.number(),
        orgIds: z.array(z.string().uuid()),
      })),
    }),
  }),
};

// Error response schema (400) for POST /api/:version/mint/organizations/resolve
export const ResolveOrganizationsError400Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type ResolveOrganizationsError400 = z.infer<typeof ResolveOrganizationsError400Schema>;

// Error response schema (500) for POST /api/:version/mint/organizations/resolve
export const ResolveOrganizationsError500Schema = z.object({
  message: z.string(),
  content: z.object({}).nullable(),
});

export type ResolveOrganizationsError500 = z.infer<typeof ResolveOrganizationsError500Schema>;

// GET /api/:version/mint/organizations/:orgNumber
export const GetOrganizationByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      organization: z.object({
        orgNumber: z.coerce.number(),
        orgCode: z.string(),
        name: z.string(),
        website: z.string().nullable(),
        country: z.string(),
        emailId: z.string(),
        archiveDate: z.coerce.number().nullable(),
        type: z.string().nullable(),
        role: z.string().nullable(),
        accountManagerId: z.string().nullable(),
        phone: z.string().nullable(),
        taxId: z.string().nullable(),
        employeeCount: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/mint/organizations/:orgNumber
export const ArchiveOrganizationRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.unknown(),
};

// POST /api/:version/mint/organizations/:orgNumber/unarchive
export const UnarchiveOrganizationRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      organization: z.object({
        orgNumber: z.coerce.number(),
        orgCode: z.string(),
        name: z.string(),
        website: z.string().nullable(),
        country: z.string(),
        emailId: z.string(),
        archiveDate: z.coerce.number().nullable(),
        type: z.string().nullable(),
        role: z.string().nullable(),
        accountManagerId: z.string().nullable(),
        phone: z.string().nullable(),
        taxId: z.string().nullable(),
        employeeCount: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// GET /api/:version/mint/organizations/:orgNumber/memberships
export const GetOrganizationMembershipsRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      memberships: z.array(z.object({
        membershipNumber: z.coerce.number(),
        status: z.enum(["active", "inactive"]),
        joinedAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        archiveDate: z.coerce.number().nullable(),
        role: z.object({
          roleNumber: z.coerce.number(),
          roleName: z.string(),
        }),
        user: z.object({
          userNumber: z.coerce.number(),
          firstName: z.string(),
          lastName: z.string(),
          emailAddress: z.string(),
          userStatus: z.enum(["active", "suspended", "archived"]),
        }),
      })),
      total: z.coerce.number().gte(0),
    }),
  }),
};

// POST /api/:version/mint/organizations/:orgNumber/memberships
export const UpsertOrganizationMembershipRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      membershipNumber: z.coerce.number().nullish(),
      userNumber: z.coerce.number().nullish(),
      roleNumber: z.coerce.number().nullish(),
      status: z.enum(["active", "inactive"]).nullish(),
    }).strict(),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      membership: z.object({
        membershipNumber: z.coerce.number(),
        status: z.enum(["active", "inactive"]),
        joinedAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        archiveDate: z.coerce.number().nullable(),
        role: z.object({
          roleNumber: z.coerce.number(),
          roleName: z.string(),
        }),
        user: z.object({
          userNumber: z.coerce.number(),
          firstName: z.string(),
          lastName: z.string(),
          emailAddress: z.string(),
          userStatus: z.enum(["active", "suspended", "archived"]),
        }),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// DELETE /api/:version/mint/organizations/:orgNumber/memberships/:membershipNumber
export const ArchiveOrganizationMembershipRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
      membershipNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.unknown(),
};

// GET /api/:version/mint/memberships
export const GetMembershipsRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({
      userNumber: z.coerce.number().nullish(),
      membershipNumber: z.coerce.number().nullish(),
    }).passthrough().default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      memberships: z.array(z.object({
        membershipNumber: z.coerce.number(),
        status: z.enum(["active", "inactive"]),
        joinedAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        archiveDate: z.coerce.number().nullable(),
        role: z.object({
          roleNumber: z.coerce.number(),
          roleName: z.string(),
        }),
        user: z.object({
          userNumber: z.coerce.number(),
          firstName: z.string(),
          lastName: z.string(),
          emailAddress: z.string(),
          userStatus: z.enum(["active", "suspended", "archived"]),
        }),
        organization: z.object({
          orgNumber: z.coerce.number(),
          name: z.string(),
        }),
      })),
      total: z.coerce.number().gte(0),
    }),
  }),
};

// GET /api/:version/mint/organizations/:orgNumber/farmgrid-account
export const GetOrganizationFarmgridAccountRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      orgNumber: z.coerce.number(),
      organization: z.object({
        farmgridAccount: z.object({
          accountStatus: z.enum(["active", "inactive", "unpaid"]),
        }),
      }),
    }),
  }),
};

// PATCH /api/:version/mint/organizations/:orgNumber/farmgrid-account
export const UpdateOrganizationFarmgridAccountRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      organization: z.object({
        farmgridAccount: z.object({
          accountStatus: z.enum(["active", "inactive", "unpaid"]),
        }).strict(),
      }).strict(),
    }).strict(),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      orgNumber: z.coerce.number(),
      organization: z.object({
        farmgridAccount: z.object({
          accountStatus: z.enum(["active", "inactive", "unpaid"]),
        }),
      }),
      membershipsUpdated: z.coerce.number().gte(0),
    }),
  }),
};

// POST /api/:version/mint/addresses
export const UpsertOrganizationAddressRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      addressNumber: z.coerce.number().nullish(),
      orgNumber: z.coerce.number(),
      addressName: z.string(),
      addressType: z.enum(["Shipping Address", "Billing Address", "Head Office", "Branch Office", "Warehouse"]),
      doorNumber: z.string().nullish(),
      addressLine1: z.string(),
      addressLine2: z.string().nullish(),
      neighborhood: z.string().nullish(),
      city: z.string(),
      state: z.string(),
      postalCode: z.string(),
      country: z.string(),
      archiveDate: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      address: z.object({
        addressNumber: z.coerce.number(),
        orgNumber: z.coerce.number(),
        addressName: z.string(),
        addressType: z.string(),
        doorNumber: z.string().nullable(),
        addressLine1: z.string(),
        addressLine2: z.string().nullable(),
        neighborhood: z.string().nullable(),
        city: z.string(),
        state: z.string(),
        postalCode: z.string(),
        country: z.string(),
        archiveDate: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/mint/organizations/:orgNumber/addresses
export const GetAddressesByOrgNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      addresses: z.array(z.object({
        addressNumber: z.coerce.number(),
        orgNumber: z.coerce.number(),
        addressName: z.string(),
        addressType: z.string(),
        doorNumber: z.string().nullable(),
        addressLine1: z.string(),
        addressLine2: z.string().nullable(),
        neighborhood: z.string().nullable(),
        city: z.string(),
        state: z.string(),
        postalCode: z.string(),
        country: z.string(),
        archiveDate: z.coerce.number().nullable(),
      })),
      total: z.coerce.number().gte(0).nullable(),
    }),
  }),
};

// POST /api/:version/sensenet/stations
export const UpsertStationRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      stationNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      stationName: z.string().min(1).max(255),
      stationAddress: z.string(),
      location: z.object({
        latitude: z.coerce.number(),
        longitude: z.coerce.number(),
      }),
      stationRoadIntersections: z.string().nullish(),
      stationNotes: z.string().nullish(),
      mediaLocations: z.array(z.string()).nullish(),
      coveredBySites: z.array(z.coerce.number().gte(1000000000).lte(9999999999)).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      station: z.object({
        stationNumber: z.coerce.number(),
        stationName: z.string(),
        stationAddress: z.string(),
        location: z.object({
          latitude: z.coerce.number().nullable(),
          longitude: z.coerce.number().nullable(),
        }).nullable(),
        stationRoadIntersections: z.string().nullable(),
        stationNotes: z.string().nullable(),
        stationPictures: z.array(z.string()).nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        coveredBySites: z.array(z.coerce.number()).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensenet/stations
export const GetStationsRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({
      limit: z.coerce.number().gte(1).lte(100).nullish(),
      offset: z.coerce.number().gte(0).nullish(),
    }).passthrough().default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      stations: z.array(z.object({
        stationNumber: z.coerce.number(),
        stationName: z.string(),
        stationAddress: z.string(),
        location: z.object({
          latitude: z.coerce.number().nullable(),
          longitude: z.coerce.number().nullable(),
        }),
        stationRoadIntersections: z.string().nullable(),
        stationNotes: z.string().nullable(),
        stationPictures: z.array(z.string()).nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        coveredBySites: z.array(z.coerce.number()).nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      })),
      total: z.coerce.number().gte(0),
      limit: z.coerce.number().gte(1).nullable(),
      offset: z.coerce.number().gte(0).nullable(),
    }),
  }),
};

// GET /api/:version/sensenet/stations/:stationNumber
export const GetStationByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      stationNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      station: z.object({
        stationNumber: z.coerce.number(),
        stationName: z.string(),
        stationAddress: z.string(),
        location: z.object({
          latitude: z.coerce.number().nullable(),
          longitude: z.coerce.number().nullable(),
        }).nullable(),
        stationRoadIntersections: z.string().nullable(),
        stationNotes: z.string().nullable(),
        stationPictures: z.array(z.string()).nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        coveredBySites: z.array(z.coerce.number()).nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensenet/stations/:stationNumber
export const DeleteStationRegistry = {
  requestSchema: z.object({
    params: z.object({
      stationNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      stationNumber: z.coerce.number(),
    }),
  }),
};

// PATCH /api/:version/sensenet/stations/:stationNumber/site-coverage
export const UpdateSiteCoverageRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      stationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
      networkSiteNumbers: z.array(z.coerce.number().gte(1000000000).lte(9999999999)),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      stationNumber: z.coerce.number(),
      networkSiteNumbers: z.array(z.coerce.number()),
    }),
  }),
};

// GET /api/:version/sensenet/stations/:stationNumber/site-coverage
export const GetSiteCoverageForStationRegistry = {
  requestSchema: z.object({
    params: z.object({
      stationNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      stationNumber: z.coerce.number(),
      networkSites: z.array(z.object({
        networkSiteNumber: z.coerce.number(),
        networkSiteName: z.string(),
        networkSiteAddress: z.string(),
        location: z.object({
          latitude: z.coerce.number().nullable(),
          longitude: z.coerce.number().nullable(),
        }),
        networkSiteTechnologies: z.array(z.string()).nullable(),
        networkCorridorNumber: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// POST /api/:version/sensenet/site-coverage
export const UpsertSiteCoverageRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      stationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
      networkSiteNumber: z.coerce.number().gte(1000000000).lte(9999999999),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      siteCoverage: z.object({
        siteCoverageNumber: z.coerce.number().nullable(),
        stationNumber: z.coerce.number(),
        networkSiteNumber: z.coerce.number(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensenet/site-coverage/:stationNumber/:networkSiteNumber
export const GetSiteCoverageByKeysRegistry = {
  requestSchema: z.object({
    params: z.object({
      stationNumber: z.coerce.number(),
      networkSiteNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      siteCoverage: z.object({
        siteCoverageNumber: z.coerce.number().nullable(),
        stationNumber: z.coerce.number(),
        networkSiteNumber: z.coerce.number(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensenet/site-coverage/:stationNumber/:networkSiteNumber
export const ArchiveSiteCoverageRegistry = {
  requestSchema: z.object({
    params: z.object({
      stationNumber: z.coerce.number(),
      networkSiteNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/sensenet/network-sites
export const UpsertNetworkSiteRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      id: z.string().nullish(),
      networkSiteNumber: z.coerce.number().nullish(),
      networkSiteName: z.string(),
      networkSiteAddress: z.string(),
      location: z.object({
        latitude: z.coerce.number().nullish(),
        longitude: z.coerce.number().nullish(),
      }),
      networkSiteTechnologies: z.array(z.enum(["Wifi", "LoRa", "4G", "5G", "RTK"])).nullish(),
      networkCorridorNumber: z.coerce.number(),
      mediaLocations: z.array(z.string()).nullish(),
      mapLocations: z.array(z.string()).nullish(),
      locationNotes: z.string().nullish(),
      indoorOrOutdoorSite: z.enum(["indoor", "outdoor"]).nullish(),
      verticalStructureHeight: z.coerce.number().nullish(),
      outdoorVerticalStructureType: z.enum(["Steel Monopole", "Lattice", "Guyed", "Wooden Monopole"]).nullish(),
      indoorStructureType: z.enum(["building", "cattleShed", "barn", "greenhouse"]).nullish(),
      backhaulCapability: z.enum(["fiber", "wireless microwave", "mesh", "satellite"]).nullish(),
      shelterAvailable: z.boolean().nullish(),
      cabinetAttached: z.boolean().nullish(),
      sitePictures: z.array(z.string()).nullish(),
      activationDate: z.coerce.number().nullish(),
      archiveDate: z.coerce.number().nullish(),
      createdAt: z.coerce.number().nullish(),
      updatedAt: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkSite: z.object({
        networkSiteNumber: z.coerce.number(),
        networkSiteName: z.string(),
        networkSiteAddress: z.string(),
        location: z.object({
          latitude: z.coerce.number().nullable(),
          longitude: z.coerce.number().nullable(),
        }).nullable(),
        networkSiteTechnologies: z.array(z.enum(["Wifi", "LoRa", "4G", "5G", "RTK"])).nullable(),
        networkCorridorNumber: z.coerce.number(),
        indoorOrOutdoorSite: z.enum(["indoor", "outdoor"]).nullable(),
        verticalStructureHeight: z.coerce.number().nullable(),
        outdoorVerticalStructureType: z.string().nullable(),
        indoorStructureType: z.string().nullable(),
        backhaulCapability: z.string().nullable(),
        shelterAvailable: z.boolean().nullable(),
        cabinetAttached: z.boolean().nullable(),
        sitePictures: z.array(z.string()).nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        mapLocations: z.array(z.string()).nullable(),
        locationNotes: z.string().nullable(),
        activationDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensenet/network-sites
export const GetNetworkSitesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({
      networkCorridorNumber: z.coerce.number().nullish(),
    }).passthrough().default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkSites: z.array(z.object({
        networkSiteNumber: z.coerce.number(),
        networkSiteName: z.string(),
        networkSiteAddress: z.string(),
        networkCorridorNumber: z.coerce.number(),
        location: z.object({
          latitude: z.coerce.number().nullable(),
          longitude: z.coerce.number().nullable(),
        }).nullable(),
        networkSiteTechnologies: z.array(z.enum(["Wifi", "LoRa", "4G", "5G", "RTK"])).nullable(),
        indoorOrOutdoorSite: z.enum(["indoor", "outdoor"]).nullable(),
        verticalStructureHeight: z.coerce.number().nullable(),
        outdoorVerticalStructureType: z.string().nullable(),
        indoorStructureType: z.string().nullable(),
        backhaulCapability: z.string().nullable(),
        shelterAvailable: z.boolean().nullable(),
        cabinetAttached: z.boolean().nullable(),
        sitePictures: z.array(z.string()).nullable(),
        locationNotes: z.string().nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        mapLocations: z.array(z.string()).nullable(),
        activationDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/sensenet/network-sites/:networkSiteNumber
export const GetNetworkSiteByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      networkSiteNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkSite: z.object({
        networkSiteNumber: z.coerce.number(),
        networkSiteName: z.string(),
        networkSiteAddress: z.string(),
        location: z.object({
          latitude: z.coerce.number().nullable(),
          longitude: z.coerce.number().nullable(),
        }).nullable(),
        networkSiteTechnologies: z.array(z.enum(["Wifi", "LoRa", "4G", "5G", "RTK"])).nullable(),
        networkCorridorNumber: z.coerce.number(),
        indoorOrOutdoorSite: z.enum(["indoor", "outdoor"]).nullable(),
        verticalStructureHeight: z.coerce.number().nullable(),
        outdoorVerticalStructureType: z.string().nullable(),
        indoorStructureType: z.string().nullable(),
        backhaulCapability: z.string().nullable(),
        shelterAvailable: z.boolean().nullable(),
        cabinetAttached: z.boolean().nullable(),
        sitePictures: z.array(z.string()).nullable(),
        locationNotes: z.string().nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        mapLocations: z.array(z.string()).nullable(),
        activationDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensenet/network-sites/:networkSiteNumber
export const DeleteNetworkSiteRegistry = {
  requestSchema: z.object({
    params: z.object({
      networkSiteNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkSiteNumber: z.coerce.number(),
    }),
  }),
};

// POST /api/:version/sensenet/network-corridors
export const UpsertNetworkCorridorRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      networkCorridorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      networkCorridorName: z.string().min(1).max(120),
      description: z.string().nullish(),
      state: z.string().min(2).max(2).nullish(),
      countiesCovered: z.string().nullish(),
      zipcodesCovered: z.string().nullish(),
      numberOfPotentialSites: z.coerce.number().nullish(),
      expectedCorridorSize: z.coerce.number().nullish(),
      mediaLocations: z.array(z.string()).nullish(),
      mapLocations: z.array(z.string()).nullish(),
      partnerOrganizationNumbers: z.array(z.coerce.number().gte(1000000000).lte(9999999999)).nullish(),
      archiveDate: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkCorridor: z.object({
        networkCorridorNumber: z.coerce.number(),
        networkCorridorName: z.string(),
        description: z.string().nullable(),
        state: z.string().nullable(),
        countiesCovered: z.string().nullable(),
        zipcodesCovered: z.string().nullable(),
        numberOfPotentialSites: z.coerce.number().nullable(),
        expectedCorridorSize: z.coerce.number().nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        mapLocations: z.array(z.string()).nullable(),
        partnerOrganizationNumbers: z.array(z.coerce.number()).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensenet/network-corridors
export const GetNetworkCorridorsRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkCorridors: z.array(z.object({
        networkCorridorNumber: z.coerce.number(),
        networkCorridorName: z.string(),
        description: z.string().nullable(),
        state: z.string().nullable(),
        countiesCovered: z.string().nullable(),
        zipcodesCovered: z.string().nullable(),
        numberOfPotentialSites: z.coerce.number().nullable(),
        expectedCorridorSize: z.coerce.number().nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        mapLocations: z.array(z.string()).nullable(),
        partnerOrganizationNumbers: z.array(z.coerce.number()).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/sensenet/network-corridors/:networkCorridorNumber
export const GetNetworkCorridorByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      networkCorridorNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkCorridor: z.object({
        networkCorridorNumber: z.coerce.number(),
        networkCorridorName: z.string(),
        description: z.string().nullable(),
        state: z.string().nullable(),
        countiesCovered: z.string().nullable(),
        zipcodesCovered: z.string().nullable(),
        numberOfPotentialSites: z.coerce.number().nullable(),
        expectedCorridorSize: z.coerce.number().nullable(),
        mediaLocations: z.array(z.string()).nullable(),
        mapLocations: z.array(z.string()).nullable(),
        partnerOrganizationNumbers: z.array(z.coerce.number()).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensenet/network-corridors/:networkCorridorNumber
export const DeleteNetworkCorridorRegistry = {
  requestSchema: z.object({
    params: z.object({
      networkCorridorNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkCorridorNumber: z.coerce.number(),
    }),
  }),
};

// GET /api/:version/sensenet/network-corridors/:networkCorridorNumber/partners
export const GetNetworkCorridorPartnersRegistry = {
  requestSchema: z.object({
    params: z.object({
      networkCorridorNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkCorridorNumber: z.coerce.number(),
      partners: z.array(z.object({
        orgNumber: z.coerce.number(),
        name: z.string(),
        orgCode: z.string(),
        country: z.string(),
        emailId: z.string(),
        type: z.string().nullable(),
        role: z.string().nullable(),
      })),
    }),
  }),
};

// PATCH /api/:version/sensenet/network-corridors/:networkCorridorNumber/partners
export const UpdateNetworkCorridorPartnersRegistry = {
  requestSchema: z.object({
    params: z.object({
      networkCorridorNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      partnerOrgNumbers: z.array(z.coerce.number().gte(1000000000).lte(9999999999)),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      networkCorridorNumber: z.coerce.number(),
      partnerOrgNumbers: z.array(z.coerce.number()),
    }),
  }),
};

// POST /api/:version/sensory/devices
export const UpsertDeviceRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      device: z.object({
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceName: z.string().min(1).max(255).nullish(),
        deviceStatus: z.enum(["ordered", "shipped", "received", "testing", "tested", "failed", "available", "live", "provisioned", "retired", "faulty", "returned", "procured"]),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceKeyInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceProvisioningInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        devicePictureLocation: z.array(z.string().max(2048)).nullish(),
        archiveDate: z.coerce.number().nullish(),
      }),
      procurementInfo: z.object({
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceDistributorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        devicePurchaseOrderNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceOrderDate: z.coerce.number().nullish(),
        shipperName: z.enum(["ups", "usps", "fedex"]).nullish(),
        deviceShippingDate: z.coerce.number().nullish(),
        deviceShippedToAddress: z.object({
          addressNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
          orgNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
          addressName: z.string().max(120).nullish(),
          addressType: z.enum(["Shipping Address", "Billing Address", "Head Office", "Branch Office", "Warehouse"]).nullish(),
          doorNumber: z.string().max(20).nullish(),
          addressLine1: z.string().max(120).nullish(),
          addressLine2: z.string().max(120).nullish(),
          neighborhood: z.string().max(120).nullish(),
          city: z.string().max(80).nullish(),
          state: z.string().max(80).nullish(),
          postalCode: z.string().max(20).nullish(),
          country: z.string().max(60).nullish(),
          archiveDate: z.coerce.number().nullish(),
        }).nullish(),
        deviceShippingTrackingNumber: z.string().max(64).nullish(),
        deviceDeliveryDate: z.coerce.number().nullish(),
        deviceProcurementStatus: z.enum(["ordered", "shipped", "received", "tested", "failed"]).nullish(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        archiveDate: z.coerce.number().nullish(),
      }).nullish(),
      retirementInfo: z.object({
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceRetirementDate: z.coerce.number().nullish(),
        archiveDate: z.coerce.number().nullish(),
      }).nullish(),
      faultInfo: z.object({
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceFaultyDate: z.coerce.number().nullish(),
        deviceFaultyNotes: z.string().max(512).nullish(),
        deviceReturned: z.boolean().nullish(),
        archiveDate: z.coerce.number().nullish(),
      }).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      device: z.object({
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceStatus: z.enum(["ordered", "shipped", "received", "testing", "tested", "failed", "available", "live", "provisioned", "retired", "faulty", "returned", "procured"]),
        deviceName: z.string().nullable(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceProvisioningInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        devicePictureLocation: z.array(z.string().max(2048)).nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
      procurementInfo: z.object({
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceDistributorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        devicePurchaseOrderNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceOrderDate: z.coerce.number().nullable(),
        shipperName: z.enum(["ups", "usps", "fedex"]).nullable(),
        deviceShippingDate: z.coerce.number().nullable(),
        deviceShippedToAddress: z.object({
          addressNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
          orgNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
          addressName: z.string().max(120).nullable(),
          addressType: z.enum(["Shipping Address", "Billing Address", "Head Office", "Branch Office", "Warehouse"]).nullable(),
          doorNumber: z.string().max(20).nullable(),
          addressLine1: z.string().max(120).nullable(),
          addressLine2: z.string().max(120).nullable(),
          neighborhood: z.string().max(120).nullable(),
          city: z.string().max(80).nullable(),
          state: z.string().max(80).nullable(),
          postalCode: z.string().max(20).nullable(),
          country: z.string().max(60).nullable(),
          archiveDate: z.coerce.number().nullable(),
        }).nullable(),
        deviceShippingTrackingNumber: z.string().max(64).nullable(),
        deviceDeliveryDate: z.coerce.number().nullable(),
        deviceProcurementStatus: z.enum(["ordered", "shipped", "received", "tested", "failed"]).nullable(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        archiveDate: z.coerce.number().nullable(),
      }).nullable(),
      retirementInfo: z.object({
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceRetirementDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }).nullable(),
      faultInfo: z.object({
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceFaultyDate: z.coerce.number().nullable(),
        deviceFaultyNotes: z.string().max(512).nullable(),
        deviceReturned: z.boolean().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }).nullable(),
      operation: z.enum(["created", "updated"]).nullable(),
    }),
  }),
};

// GET /api/:version/sensory/devices
export const GetDevicesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      devices: z.array(z.object({
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceStatus: z.enum(["ordered", "shipped", "received", "testing", "tested", "failed", "available", "live", "provisioned", "retired", "faulty", "returned", "procured"]),
        deviceName: z.string().nullable(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceTypeName: z.string().nullable(),
        deviceTypeCategory: z.string().nullable(),
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceProvisioningInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceKeyInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        devicePictureLocation: z.array(z.string().max(2048)).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/sensory/devices/:deviceNumber
export const GetDeviceByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      device: z.object({
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceStatus: z.enum(["ordered", "shipped", "received", "testing", "tested", "failed", "available", "live", "provisioned", "retired", "faulty", "returned", "procured"]),
        deviceName: z.string().nullable(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceProvisioningInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        devicePictureLocation: z.array(z.string().max(2048)).nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
      procurementInfo: z.object({
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceDistributorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        devicePurchaseOrderNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceOrderDate: z.coerce.number().nullable(),
        shipperName: z.enum(["ups", "usps", "fedex"]).nullable(),
        deviceShippingDate: z.coerce.number().nullable(),
        deviceShippedToAddress: z.object({
          addressNumber: z.coerce.number().nullable(),
          orgNumber: z.coerce.number().nullable(),
          addressName: z.string().max(120).nullable(),
          addressType: z.enum(["Shipping Address", "Billing Address", "Head Office", "Branch Office", "Warehouse"]).nullable(),
          doorNumber: z.string().max(20).nullable(),
          addressLine1: z.string().max(120).nullable(),
          addressLine2: z.string().max(120).nullable(),
          neighborhood: z.string().max(120).nullable(),
          city: z.string().max(80).nullable(),
          state: z.string().max(80).nullable(),
          postalCode: z.string().max(20).nullable(),
          country: z.string().max(60).nullable(),
          archiveDate: z.coerce.number().nullable(),
        }).nullable(),
        deviceShippingTrackingNumber: z.string().max(64).nullable(),
        deviceDeliveryDate: z.coerce.number().nullable(),
        deviceProcurementStatus: z.enum(["ordered", "shipped", "received", "tested", "failed"]).nullable(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        archiveDate: z.coerce.number().nullable(),
      }).nullable(),
      provisioningInfo: z.object({
        deviceProvisioningInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        networkCorridorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        networkSiteNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        networkCorridorName: z.string().nullable(),
        networkSiteName: z.string().nullable(),
        deviceProvisioningStatus: z.enum(["requested", "success", "failed", "deprovisioned"]).nullable(),
        deviceProvisioningType: z.enum(["test", "live"]).nullable(),
        deviceProvisionRequestedDate: z.coerce.number().nullable(),
        deviceProvisionedDate: z.coerce.number().nullable(),
        deviceDeprovisionedDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }).nullable(),
      retirementInfo: z.object({
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceRetirementDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }).nullable(),
      faultInfo: z.object({
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceFaultyDate: z.coerce.number().nullable(),
        deviceFaultyNotes: z.string().max(512).nullable(),
        deviceReturned: z.boolean().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }).nullable(),
    }),
  }),
};

// DELETE /api/:version/sensory/devices/:deviceNumber
export const ArchiveDeviceRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/sensory/devices/:deviceNumber/procurement-info
export const UpsertDeviceProcurementInfoRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      procurementInfo: z.object({
        id: z.string().uuid().nullish(),
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceDistributorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        devicePurchaseOrderNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceOrderDate: z.coerce.number().nullish(),
        shipperName: z.enum(["ups", "usps", "fedex"]).nullish(),
        deviceShippingDate: z.coerce.number().nullish(),
        deviceShippedToAddressNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceShippingTrackingNumber: z.string().max(64).nullish(),
        deviceDeliveryDate: z.coerce.number().nullish(),
        deviceProcurementStatus: z.enum(["ordered", "shipped", "received", "testing", "tested", "failed"]).nullish(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceTestingCompletedDate: z.coerce.number().nullish(),
        archiveDate: z.coerce.number().nullish(),
      }),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      procurementInfo: z.object({
        deviceProcurementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceDistributorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        devicePurchaseOrderNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceOrderDate: z.coerce.number().nullable(),
        shipperName: z.enum(["ups", "usps", "fedex"]).nullable(),
        deviceShippingDate: z.coerce.number().nullable(),
        deviceShippedToAddressNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceShippingTrackingNumber: z.string().max(64).nullable(),
        deviceDeliveryDate: z.coerce.number().nullable(),
        deviceProcurementStatus: z.enum(["ordered", "shipped", "received", "testing", "tested", "failed"]).nullable(),
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceTestingCompletedDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// POST /api/:version/sensory/devices/:deviceNumber/provisioning-info
export const UpsertDeviceProvisioningInfoRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      provisioningInfo: z.object({
        id: z.string().uuid().nullish(),
        deviceProvisioningInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        provisionedDeviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        networkCorridorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        networkSiteNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceProvisionRequestedDate: z.coerce.number().nullish(),
        deviceProvisionedRequestedBy: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceProvisioningStatus: z.enum(["requested", "success", "failed", "deprovisioned"]).nullish(),
        deviceProvisioningType: z.enum(["test", "live"]).nullish(),
        archiveDate: z.coerce.number().nullish(),
      }),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      provisioningInfo: z.object({
        deviceProvisioningInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        provisionedDeviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        networkCorridorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        networkSiteNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceProvisionRequestedDate: z.coerce.number().nullable(),
        deviceProvisionedRequestedBy: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceProvisioningStatus: z.enum(["requested", "success", "failed", "deprovisioned"]),
        deviceProvisioningType: z.enum(["test", "live"]).nullable(),
        networkCorridorName: z.string().nullable(),
        networkSiteName: z.string().nullable(),
        deviceProvisionedDate: z.coerce.number().nullable(),
        deviceDeprovisionedDate: z.coerce.number().nullable(),
        deviceDeprovisionedBy: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// POST /api/:version/sensory/devices/:deviceNumber/retirement-info
export const UpsertDeviceRetirementInfoRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      retirementInfo: z.object({
        id: z.string().uuid().nullish(),
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceRetirementDate: z.coerce.number().nullish(),
        archiveDate: z.coerce.number().nullish(),
      }),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      retirementInfo: z.object({
        deviceRetirementInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceRetirementDate: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// POST /api/:version/sensory/devices/:deviceNumber/fault-info
export const UpsertDeviceFaultInfoRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      faultInfo: z.object({
        id: z.string().uuid().nullish(),
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceFaultyDate: z.coerce.number().nullish(),
        deviceFaultyNotes: z.string().max(512).nullish(),
        deviceReturned: z.boolean().nullish(),
        archiveDate: z.coerce.number().nullish(),
      }),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      faultInfo: z.object({
        deviceFaultInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceFaultyDate: z.coerce.number().nullable(),
        deviceFaultyNotes: z.string().max(512).nullable(),
        deviceReturned: z.boolean().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensory/devices/procurement/addresses
export const GetAddressListForDeviceProcurementRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      addresses: z.array(z.object({
        addressNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        addressName: z.string().min(1).max(120).nullable(),
      })),
    }),
  }),
};

// POST /api/:version/sensory/device-profiles
export const UpsertDeviceProfileRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      deviceProfileNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      deviceProfileName: z.string().min(3).max(60),
      deviceProfileNetwork: z.enum(["LoRa", "WiFi", "BLE", "Zigbee"]),
      deviceProfileLoraAttributes: z.object({
        region: z.enum(["US915"]).nullish(),
        regionConfiguration: z.enum(["US915 (channels 8-15 + 65)"]).nullish(),
        macVersion: z.enum(["LoRaWAN 1.0.1", "LoRaWAN 1.0.2", "LoRaWAN 1.0.3", "LoRaWAN 1.0.4", "LoRaWAN 1.1.0"]).nullish(),
        macRegionalParameters: z.enum(["A", "B", "RP002-1.0.0", "RP002-1.0.1", "RP002-1.0.2", "RP002-1.0.3", "RP002-1.0.4"]).nullish(),
        adrAlgorithm: z.enum(["Default ADR algorithm (LoRa only)", "LR-FHSS only ADR algorithm", "LoRa & LR-FHSS ADR algorithm"]).nullish(),
        expectedUplinkInterval: z.object({}).catchall(z.unknown()).nullish(),
        rx1delay: z.coerce.number().gte(0).nullish(),
        deviceSupportsOtaa: z.boolean().nullish(),
        devicesupportsClassA: z.boolean().nullish(),
        devicesupportsClassB: z.boolean().nullish(),
        codec: z.string().max(120).nullish(),
      }),
      deviceProfileWifiAttributes: z.object({}).catchall(z.unknown()).nullish(),
      deviceProfileBleAttributes: z.object({}).catchall(z.unknown()).nullish(),
      deviceProfileZigbeeAttributes: z.object({}).catchall(z.unknown()).nullish(),
      archiveDate: z.coerce.number().nullish(),
      createdAt: z.coerce.number().nullish(),
      updatedAt: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceProfile: z.object({
        deviceProfileNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceProfileName: z.string().min(3).max(60),
        deviceProfileNetwork: z.enum(["LoRa", "WiFi", "BLE", "Zigbee"]),
        deviceProfileLoraAttributes: z.object({
          region: z.enum(["US915"]).nullable(),
          regionConfiguration: z.enum(["US915 (channels 8-15 + 65)"]).nullable(),
          macVersion: z.enum(["LoRaWAN 1.0.1", "LoRaWAN 1.0.2", "LoRaWAN 1.0.3", "LoRaWAN 1.0.4", "LoRaWAN 1.1.0"]).nullable(),
          macRegionalParameters: z.enum(["A", "B", "RP002-1.0.0", "RP002-1.0.1", "RP002-1.0.2", "RP002-1.0.3", "RP002-1.0.4"]).nullable(),
          adrAlgorithm: z.enum(["Default ADR algorithm (LoRa only)", "LR-FHSS only ADR algorithm", "LoRa & LR-FHSS ADR algorithm"]).nullable(),
          expectedUplinkInterval: z.object({}).catchall(z.unknown()).nullable(),
          rx1delay: z.coerce.number().gte(0).nullable(),
          deviceSupportsOtaa: z.boolean().nullable(),
          devicesupportsClassA: z.boolean().nullable(),
          devicesupportsClassB: z.boolean().nullable(),
          codec: z.string().max(120).nullable(),
        }).nullable(),
        deviceProfileWifiAttributes: z.object({}).catchall(z.unknown()).nullable(),
        deviceProfileBleAttributes: z.object({}).catchall(z.unknown()).nullable(),
        deviceProfileZigbeeAttributes: z.object({}).catchall(z.unknown()).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensory/device-profiles
export const GetDeviceProfilesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceProfiles: z.array(z.object({
        deviceProfileNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceProfileName: z.string().min(3).max(60),
        deviceProfileNetwork: z.enum(["LoRa", "WiFi", "BLE", "Zigbee"]),
        deviceProfileLoraAttributes: z.object({}).catchall(z.unknown()).nullable(),
        deviceProfileWifiAttributes: z.object({}).catchall(z.unknown()).nullable(),
        deviceProfileBleAttributes: z.object({}).catchall(z.unknown()).nullable(),
        deviceProfileZigbeeAttributes: z.object({}).catchall(z.unknown()).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/sensory/device-profiles/:deviceProfileNumber
export const GetDeviceProfileRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceProfileNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceProfile: z.object({
        deviceProfileNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceProfileName: z.string().min(3).max(60),
        deviceProfileNetwork: z.enum(["LoRa", "WiFi", "BLE", "Zigbee"]),
        deviceProfileLoraAttributes: z.object({
          region: z.enum(["US915"]).nullable(),
          regionConfiguration: z.enum(["US915 (channels 8-15 + 65)"]).nullable(),
          macVersion: z.enum(["LoRaWAN 1.0.1", "LoRaWAN 1.0.2", "LoRaWAN 1.0.3", "LoRaWAN 1.0.4", "LoRaWAN 1.1.0"]).nullable(),
          macRegionalParameters: z.enum(["A", "B", "RP002-1.0.0", "RP002-1.0.1", "RP002-1.0.2", "RP002-1.0.3", "RP002-1.0.4"]).nullable(),
          adrAlgorithm: z.enum(["Default ADR algorithm (LoRa only)", "LR-FHSS only ADR algorithm", "LoRa & LR-FHSS ADR algorithm"]).nullable(),
          expectedUplinkInterval: z.object({}).catchall(z.unknown()).nullable(),
          rx1delay: z.coerce.number().gte(0).nullable(),
          deviceSupportsOtaa: z.boolean().nullable(),
          devicesupportsClassA: z.boolean().nullable(),
          devicesupportsClassB: z.boolean().nullable(),
          codec: z.string().max(120).nullable(),
        }).nullable(),
        deviceProfileWifiAttributes: z.object({}).catchall(z.unknown()).nullable(),
        deviceProfileBleAttributes: z.object({}).catchall(z.unknown()).nullable(),
        deviceProfileZigbeeAttributes: z.object({}).catchall(z.unknown()).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensory/device-profiles/:deviceProfileNumber
export const ArchiveDeviceProfileRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceProfileNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/sensory/device-key-info
export const UpsertDeviceKeyInfoRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      deviceKeyInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
      deviceSerialNumber: z.string().min(1).max(120),
      deviceEUI: z.string().regex(new RegExp("^([0-9A-Fa-f]{2}[-:]){7}([0-9A-Fa-f]{2})$")),
      deviceJoinEUI: z.string().regex(new RegExp("^([0-9A-Fa-f]{2}[-:]){7}([0-9A-Fa-f]{2})$")),
      deviceAppKey: z.object({
        rootKey: z.string().min(32).max(32).regex(new RegExp("^[a-fA-F0-9]{32}$")),
      }),
      deviceAddress: z.string().min(1).max(64),
      deviceNETSKey: z.string().min(1).max(64),
      deviceAPPSKey: z.string().min(1).max(64),
      archiveDate: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceKeyInfo: z.object({
        deviceKeyInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceSerialNumber: z.string().min(1).max(120),
        deviceEUI: z.string().regex(new RegExp("^([0-9A-Fa-f]{2}[-:]){7}([0-9A-Fa-f]{2})$")),
        deviceJoinEUI: z.string().regex(new RegExp("^([0-9A-Fa-f]{2}[-:]){7}([0-9A-Fa-f]{2})$")),
        deviceAppKey: z.object({
          rootKey: z.string().min(32).max(32).regex(new RegExp("^[a-fA-F0-9]{32}$")),
        }),
        deviceAddress: z.string().min(1).max(64),
        deviceNETSKey: z.string().min(1).max(64),
        deviceAPPSKey: z.string().min(1).max(64),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensory/device-key-info/:deviceKeyInfoNumber
export const GetDeviceKeyInfoRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceKeyInfoNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceKeyInfo: z.object({
        deviceKeyInfoNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceSerialNumber: z.string().min(1).max(120),
        deviceEUI: z.string().regex(new RegExp("^([0-9A-Fa-f]{2}[-:]){7}([0-9A-Fa-f]{2})$")),
        deviceJoinEUI: z.string().regex(new RegExp("^([0-9A-Fa-f]{2}[-:]){7}([0-9A-Fa-f]{2})$")),
        deviceAppKey: z.object({
          rootKey: z.string().min(32).max(32).regex(new RegExp("^[a-fA-F0-9]{32}$")),
        }),
        deviceAddress: z.string().min(1).max(64),
        deviceNETSKey: z.string().min(1).max(64),
        deviceAPPSKey: z.string().min(1).max(64),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensory/device-key-info/:deviceKeyInfoNumber
export const ArchiveDeviceKeyInfoRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceKeyInfoNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/sensory/manufacturers
export const UpsertDeviceManufacturerRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      manufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      manufacturerName: z.string().min(3).max(60),
      archiveDate: z.coerce.number().nullish(),
      createdAt: z.coerce.number().nullish(),
      updatedAt: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      manufacturer: z.object({
        manufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        manufacturerName: z.string().min(3).max(60),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensory/manufacturers
export const GetDeviceManufacturersRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      manufacturers: z.array(z.object({
        manufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        manufacturerName: z.string().min(3).max(60),
        archiveDate: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/sensory/manufacturers/:manufacturerNumber
export const GetDeviceManufacturerRegistry = {
  requestSchema: z.object({
    params: z.object({
      manufacturerNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      manufacturer: z.object({
        manufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        manufacturerName: z.string().min(3).max(60),
        archiveDate: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensory/manufacturers/:manufacturerNumber
export const ArchiveDeviceManufacturerRegistry = {
  requestSchema: z.object({
    params: z.object({
      manufacturerNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/sensory/distributors
export const UpsertDeviceDistributorRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      distributorNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      distributorName: z.string().min(3).max(60),
      archiveDate: z.coerce.number().nullish(),
      createdAt: z.coerce.number().nullish(),
      updatedAt: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      distributor: z.object({
        distributorNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        distributorName: z.string().min(3).max(60),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensory/distributors
export const GetDeviceDistributorsRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      distributors: z.array(z.object({
        distributorNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        distributorName: z.string().min(3).max(60),
        archiveDate: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/sensory/distributors/:distributorNumber
export const GetDeviceDistributorRegistry = {
  requestSchema: z.object({
    params: z.object({
      distributorNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      distributor: z.object({
        distributorNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        distributorName: z.string().min(3).max(60),
        archiveDate: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensory/distributors/:distributorNumber
export const ArchiveDeviceDistributorRegistry = {
  requestSchema: z.object({
    params: z.object({
      distributorNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/sensory/device-types
export const UpsertDeviceTypeRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      deviceTypeName: z.string().min(3).max(60),
      deviceTypeManufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999),
      deviceTypeModel: z.string().min(1).max(40),
      deviceTypeStatus: z.enum(["research", "testing", "certified"]).nullish(),
      deviceTypeCategory: z.enum(["Weather Sensor", "Soil Sensor", "Camera", "Motion Sensor", "Relay Controller", "Solenoid Valve Controller", "Flow Meter", "Electric Current Sensor"]).nullish(),
      archiveDate: z.coerce.number().nullish(),
      createdAt: z.coerce.number().nullish(),
      updatedAt: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceType: z.object({
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceTypeName: z.string().min(3).max(60),
        deviceTypeManufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceTypeModel: z.string().min(1).max(40).nullable(),
        deviceTypeStatus: z.enum(["research", "testing", "certified"]).nullable(),
        deviceTypeCategory: z.enum(["Weather Sensor", "Soil Sensor", "Camera", "Motion Sensor", "Relay Controller", "Solenoid Valve Controller", "Flow Meter", "Electric Current Sensor"]).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensory/device-types
export const GetDeviceTypesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceTypes: z.array(z.object({
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceTypeName: z.string().min(3).max(60),
        deviceTypeManufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceTypeModel: z.string().min(1).max(40).nullable(),
        deviceTypeStatus: z.enum(["research", "testing", "certified"]).nullable(),
        deviceTypeCategory: z.enum(["Weather Sensor", "Soil Sensor", "Camera", "Motion Sensor", "Relay Controller", "Solenoid Valve Controller", "Flow Meter", "Electric Current Sensor"]).nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/sensory/device-types/:deviceTypeNumber
export const GetDeviceTypeRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceTypeNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      deviceType: z.object({
        deviceTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        deviceTypeName: z.string().min(3).max(60),
        deviceTypeManufacturerNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceTypeModel: z.string().min(1).max(40).nullable(),
        deviceTypeStatus: z.enum(["research", "testing", "certified"]).nullable(),
        deviceTypeCategory: z.enum(["Weather Sensor", "Soil Sensor", "Camera", "Motion Sensor", "Relay Controller", "Solenoid Valve Controller", "Flow Meter", "Electric Current Sensor"]).nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensory/device-types/:deviceTypeNumber
export const ArchiveDeviceTypeRegistry = {
  requestSchema: z.object({
    params: z.object({
      deviceTypeNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/conex-configs/fetch-types
export const UpsertFetchTypeRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      fetchTypeName: z.string().min(1).max(255),
      fetchTypeDescription: z.string().max(500).nullish(),
      sourceOrganizationId: z.string().uuid(),
      deviceTypeId: z.string().uuid(),
      sourceMethod: z.enum(["internalMQTT", "externalMQTT", "httpPull", "ftp", "webhook"]),
      sourceConfigs: z.object({}).catchall(z.unknown()),
      fetchTypeKeys: z.array(z.string()),
      fetchTypeStatus: z.enum(["active", "suspended", "disabled"]),
      archiveDate: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      fetchType: z.object({
        fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        fetchTypeName: z.string(),
        fetchTypeDescription: z.string().nullable(),
        sourceOrganizationId: z.string().uuid(),
        deviceTypeId: z.string().uuid(),
        sourceMethod: z.enum(["internalMQTT", "externalMQTT", "httpPull", "ftp", "webhook"]),
        sourceConfigs: z.object({}).catchall(z.unknown()),
        fetchTypeKeys: z.array(z.string()),
        fetchTypeStatus: z.enum(["active", "suspended", "disabled"]),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/conex-configs/fetch-types
export const GetFetchTypesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      fetchTypes: z.array(z.object({
        fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        fetchTypeName: z.string(),
        fetchTypeDescription: z.string().nullable(),
        sourceOrganizationId: z.string().uuid(),
        deviceTypeId: z.string().uuid(),
        sourceMethod: z.enum(["internalMQTT", "externalMQTT", "httpPull", "ftp", "webhook"]),
        sourceConfigs: z.object({}).catchall(z.unknown()),
        fetchTypeKeys: z.array(z.string()),
        fetchTypeStatus: z.enum(["active", "suspended", "disabled"]),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/conex-configs/fetch-types/:fetchTypeNumber
export const GetFetchTypeRegistry = {
  requestSchema: z.object({
    params: z.object({
      fetchTypeNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      fetchType: z.object({
        fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        fetchTypeName: z.string(),
        fetchTypeDescription: z.string().nullable(),
        sourceOrganizationId: z.string().uuid(),
        deviceTypeId: z.string().uuid(),
        sourceMethod: z.enum(["internalMQTT", "externalMQTT", "httpPull", "ftp", "webhook"]),
        sourceConfigs: z.object({}).catchall(z.unknown()),
        fetchTypeKeys: z.array(z.string()),
        fetchTypeStatus: z.enum(["active", "suspended", "disabled"]),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/conex-configs/fetch-types/:fetchTypeNumber
export const ArchiveFetchTypeRegistry = {
  requestSchema: z.object({
    params: z.object({
      fetchTypeNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/conex-ops/fetch-instances
export const CreateFetchInstancesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      fetchTypeNumbers: z.array(z.coerce.number().gte(1000000000).lte(9999999999)).min(1),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      fetchInstances: z.array(z.object({
        fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        devices: z.array(z.object({
          fetchInstanceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
          deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999),
          providerDeviceIdentifier: z.object({}).catchall(z.string()).nullable(),
          lastReading: z.coerce.number().nullable(),
        })),
      })),
    }),
  }),
};

// GET /api/:version/conex-ops/fetch-instances
export const GetFetchInstancesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({
      fetchInstanceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      status: z.enum(["new", "success", "fail"]).nullish(),
    }).passthrough().default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      fetchInstances: z.array(z.object({
        fetchInstanceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        status: z.enum(["new", "success", "fail"]),
        sourceFetchStatus: z.enum(["success", "fail"]).nullable(),
        landingZoneSavedStatus: z.enum(["success", "fail"]).nullable(),
        lastFetchedTime: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/conex-ops/fetch-instances/:fetchInstanceNumber
export const GetFetchInstanceRegistry = {
  requestSchema: z.object({
    params: z.object({
      fetchInstanceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      fetchInstance: z.object({
        fetchInstanceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        status: z.enum(["new", "success", "fail"]),
        sourceFetchStatus: z.enum(["success", "fail"]).nullable(),
        landingZoneSavedStatus: z.enum(["success", "fail"]).nullable(),
        lastFetchedTime: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// PATCH /api/:version/conex-ops/fetch-instances/:fetchInstanceNumber
export const UpdateFetchInstanceStatusRegistry = {
  requestSchema: z.object({
    params: z.object({
      fetchInstanceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      status: z.enum(["new", "success", "fail"]),
      lastFetchedTime: z.coerce.number(),
      sourceFetchStatus: z.enum(["success", "fail"]).nullish(),
      landingZoneSavedStatus: z.enum(["success", "fail"]).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      fetchInstance: z.object({
        fetchInstanceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        fetchTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        deviceNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        status: z.enum(["new", "success", "fail"]),
        sourceFetchStatus: z.enum(["success", "fail"]).nullable(),
        landingZoneSavedStatus: z.enum(["success", "fail"]).nullable(),
        lastFetchedTime: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// POST /api/:version/engage/subscribe
export const MailChimpSubscribeRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      email_address: z.string().email(),
      merge_fields: z.object({
        FNAME: z.string(),
        LNAME: z.string(),
        CNAME: z.string().nullish(),
      }),
      tag: z.object({}).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      subscribed: z.boolean(),
      email_address: z.string().email(),
      listId: z.string().nullable(),
    }),
  }),
};

// POST /api/:version/uniq/invitations
export const UpsertInvitationRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}),
    body: z.object({
      invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      invitationType: z.string().min(1).max(100).regex(new RegExp("^[a-z][A-Za-z0-9]*$")),
      targetReference: z.string().min(1).max(500).nullish(),
      firstName: z.string().min(1),
      lastName: z.string().min(1),
      emailId: z.string().email(),
      mobileNumber: z.string().regex(new RegExp("^\\+[1-9][0-9]{7,14}$")).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitation: z.object({
        invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        invitationType: z.string(),
        targetKind: z.enum(["organization", "none"]),
        targetReference: z.string().nullable(),
        firstName: z.string(),
        lastName: z.string(),
        emailId: z.string().email(),
        mobileNumber: z.string().nullable(),
        inviterUserNumber: z.coerce.number(),
        status: z.enum(["pending", "accepted", "redeemed", "declined", "revoked", "expired"]),
        expiresAt: z.coerce.number(),
        acceptedAt: z.coerce.number().nullable(),
        acceptedUserNumber: z.coerce.number().nullable(),
        redeemedAt: z.coerce.number().nullable(),
        declinedAt: z.coerce.number().nullable(),
        createdAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/uniq/invitations
export const GetInvitationListRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({
      status: z.enum(["pending", "accepted", "redeemed", "declined", "revoked", "expired"]).nullish(),
      startDate: z.coerce.number().nullish(),
      endDate: z.coerce.number().nullish(),
      search: z.string().nullish(),
      invitationType: z.string().nullish(),
      targetReference: z.string().nullish(),
    }),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitations: z.array(z.object({
        invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        invitationType: z.string(),
        targetKind: z.enum(["organization", "none"]),
        targetReference: z.string().nullable(),
        firstName: z.string(),
        lastName: z.string(),
        emailId: z.string().email(),
        mobileNumber: z.string().nullable(),
        inviterUserNumber: z.coerce.number(),
        status: z.enum(["pending", "accepted", "redeemed", "declined", "revoked", "expired"]),
        expiresAt: z.coerce.number(),
        acceptedAt: z.coerce.number().nullable(),
        acceptedUserNumber: z.coerce.number().nullable(),
        redeemedAt: z.coerce.number().nullable(),
        declinedAt: z.coerce.number().nullable(),
        createdAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
      })),
    }),
  }),
};

// POST /api/:version/uniq/invitations/accept
export const AcceptInvitationRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}),
    body: z.object({
      token: z.string().min(32).max(32),
      email: z.string().email().nullish(),
      mobileNumber: z.string().regex(new RegExp("^\\+[1-9][0-9]{7,14}$")).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        created: z.boolean(),
      }),
    }),
  }),
};

// POST /api/:version/uniq/invitations/accept-by-email
export const AcceptInvitationByEmailRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}),
    body: z.object({
      email: z.string().email(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number().gte(1000000000).lte(9999999999),
        created: z.boolean(),
      }),
    }),
  }),
};

// POST /api/:version/uniq/invitations/decline
export const DeclineInvitationRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}),
    body: z.object({
      token: z.string().min(32).max(32),
      email: z.string().email().nullish(),
      mobileNumber: z.string().regex(new RegExp("^\\+[1-9][0-9]{7,14}$")).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
      status: z.enum(["declined"]),
    }),
  }),
};

// DELETE /api/:version/uniq/invitations/:invitationNumber
export const RevokeInvitationRegistry = {
  requestSchema: z.object({
    params: z.object({
      invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
    }),
    query: z.object({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
    }),
  }),
};

// POST /api/:version/uniq/invitations/:invitationNumber/resend
export const ResendInvitationRegistry = {
  requestSchema: z.object({
    params: z.object({
      invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
    }),
    query: z.object({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitationNumber: z.coerce.number().gte(1000000000).lte(9999999999),
    }),
  }),
};

// GET /api/:version/uniq/invitation-types
export const GetInvitationTypesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({
      status: z.enum(["active", "inactive"]).nullish(),
      includeArchived: z.enum(["true", "false"]).nullish(),
    }),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitationTypes: z.array(z.object({
        invitationTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        invitationTypeName: z.string(),
        invitationTypeLabel: z.string(),
        invitationTypeDescription: z.string().nullable(),
        targetKind: z.enum(["organization", "none"]),
        status: z.enum(["active", "inactive"]).nullable(),
        hasHandler: z.boolean(),
        pendingInvitationCount: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// POST /api/:version/uniq/invitation-types
export const UpsertInvitationTypeRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}),
    body: z.object({
      invitationTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullish(),
      invitationTypeName: z.string().min(1).max(100).regex(new RegExp("^[a-z][A-Za-z0-9]*$")),
      invitationTypeLabel: z.string().min(1).max(150),
      invitationTypeDescription: z.string().max(500).nullish(),
      targetKind: z.enum(["organization", "none"]),
      status: z.enum(["active", "inactive"]).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitationType: z.object({
        invitationTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        invitationTypeName: z.string(),
        invitationTypeLabel: z.string(),
        invitationTypeDescription: z.string().nullable(),
        targetKind: z.enum(["organization", "none"]),
        status: z.enum(["active", "inactive"]).nullable(),
        hasHandler: z.boolean(),
        pendingInvitationCount: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/uniq/invitation-types/:invitationTypeNumber
export const GetInvitationTypeRegistry = {
  requestSchema: z.object({
    params: z.object({
      invitationTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999),
    }),
    query: z.object({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      invitationType: z.object({
        invitationTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999).nullable(),
        invitationTypeName: z.string(),
        invitationTypeLabel: z.string(),
        invitationTypeDescription: z.string().nullable(),
        targetKind: z.enum(["organization", "none"]),
        status: z.enum(["active", "inactive"]).nullable(),
        hasHandler: z.boolean(),
        pendingInvitationCount: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/uniq/invitation-types/:invitationTypeNumber
export const ArchiveInvitationTypeRegistry = {
  requestSchema: z.object({
    params: z.object({
      invitationTypeNumber: z.coerce.number().gte(1000000000).lte(9999999999),
    }),
    query: z.object({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/uniq/job-roles
export const CreateJobRoleRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      jobRoleName: z.string().min(1).max(255),
      jobRoleDescription: z.string().max(2000).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      jobRole: z.object({
        jobRoleNumber: z.coerce.number(),
        jobRoleName: z.string(),
        jobRoleDescription: z.string().nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/uniq/job-roles
export const GetJobRolesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      jobRoles: z.array(z.object({
        jobRoleNumber: z.coerce.number(),
        jobRoleName: z.string(),
        jobRoleDescription: z.string().nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// PUT /api/:version/uniq/job-roles/:jobRoleNumber
export const UpdateJobRoleRegistry = {
  requestSchema: z.object({
    params: z.object({
      jobRoleNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      jobRoleName: z.string().min(1).max(255),
      jobRoleDescription: z.string().max(2000).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      jobRole: z.object({
        jobRoleNumber: z.coerce.number(),
        jobRoleName: z.string(),
        jobRoleDescription: z.string().nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// GET /api/:version/uniq/job-roles/:jobRoleNumber
export const GetJobRoleByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      jobRoleNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      jobRole: z.object({
        jobRoleNumber: z.coerce.number(),
        jobRoleName: z.string(),
        jobRoleDescription: z.string().nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/uniq/job-roles/:jobRoleNumber
export const ArchiveJobRoleRegistry = {
  requestSchema: z.object({
    params: z.object({
      jobRoleNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/uniq/job-roles/:jobRoleNumber/users/:userNumber
export const UpsertJobRoleToUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      jobRoleNumber: z.coerce.number(),
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      userJobRole: z.object({
        userNumber: z.coerce.number(),
        jobRoleNumber: z.coerce.number(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// DELETE /api/:version/uniq/job-roles/:jobRoleNumber/users/:userNumber
export const RemoveJobRoleFromUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      jobRoleNumber: z.coerce.number(),
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      removed: z.boolean(),
    }),
  }),
};

// GET /api/:version/uniq/users/:userNumber/organizations
export const GetOrganizationsForUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      organizations: z.array(z.object({
        orgNumber: z.coerce.number().nullable(),
        orgCode: z.string().nullable(),
        name: z.string().nullable(),
        website: z.string().nullable(),
        country: z.string().nullable(),
        emailId: z.string().nullable(),
        type: z.string().nullable(),
        role: z.string().nullable(),
        accountManagerId: z.string().nullable(),
        phone: z.string().nullable(),
        taxId: z.string().nullable(),
        employeeCount: z.coerce.number().nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// POST /api/:version/uniq/users/:userNumber/organizations/:orgNumber
export const UpsertOrganizationToUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      userOrganization: z.object({
        userNumber: z.coerce.number(),
        orgNumber: z.coerce.number(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// DELETE /api/:version/uniq/users/:userNumber/organizations/:orgNumber
export const RemoveOrganizationFromUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      removed: z.boolean().nullable(),
    }),
  }),
};

// Error response schema (400) for DELETE /api/:version/uniq/users/:userNumber/organizations/:orgNumber
export const RemoveOrganizationFromUserError400Schema = z.object({
  error: z.string().nullable(),
  message: z.string().nullable(),
});

export type RemoveOrganizationFromUserError400 = z.infer<typeof RemoveOrganizationFromUserError400Schema>;

// GET /api/:version/uniq/organizations/:orgNumber/users
export const GetUsersForOrganizationRegistry = {
  requestSchema: z.object({
    params: z.object({
      orgNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      users: z.array(z.object({
        userNumber: z.coerce.number().nullable(),
        userName: z.string().nullable(),
        emailAddress: z.string().nullable(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        profilePicture: z.string().nullable(),
        userStatus: z.enum(["active", "suspended", "archived"]).nullable(),
        archiveDate: z.string().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// POST /api/:version/reMa/resource-types
export const UpsertResourceTypeRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      resourceTypeNumber: z.coerce.number().nullish(),
      resourceTypeName: z.string(),
      resourceTypeDescription: z.string(),
      namespace: z.enum(["cnx", "frg"]),
      resourceTypeCategory: z.enum(["artifact", "component", "product", "cloud", "user-data"]),
      parentResourceTypes: z.array(z.coerce.number()).nullish(),
      permissions: z.array(z.string()).nullish(),
      resourceTypeUri: z.string().nullish(),
      archiveDate: z.coerce.number().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      resourceType: z.object({
        resourceTypeNumber: z.coerce.number(),
        resourceTypeName: z.string(),
        resourceTypeDescription: z.string().nullable(),
        namespace: z.enum(["cnx", "frg"]).nullable(),
        resourceTypeCategory: z.enum(["artifact", "component", "product", "cloud", "user-data"]).nullable(),
        parentResourceTypes: z.array(z.coerce.number()).nullable(),
        permissions: z.array(z.string()).nullable(),
        resourceTypeUri: z.string().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/reMa/resource-types
export const GetResourceTypesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      resourceTypes: z.array(z.object({
        resourceTypeNumber: z.coerce.number(),
        resourceTypeName: z.string(),
        resourceTypeDescription: z.string().nullable(),
        namespace: z.enum(["cnx", "frg"]).nullable(),
        resourceTypeCategory: z.enum(["artifact", "component", "product", "cloud", "user-data"]).nullable(),
        parentResourceTypes: z.array(z.coerce.number()).nullable(),
        permissions: z.array(z.string()).nullable(),
        resourceTypeUri: z.string().nullable(),
        archiveDate: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// GET /api/:version/reMa/resource-types/:resourceTypeName
export const GetResourceTypeByNameRegistry = {
  requestSchema: z.object({
    params: z.object({
      resourceTypeName: z.string(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      resourceType: z.object({
        resourceTypeNumber: z.coerce.number(),
        resourceTypeName: z.string(),
        resourceTypeDescription: z.string().nullable(),
        namespace: z.enum(["cnx", "frg"]).nullable(),
        resourceTypeCategory: z.enum(["artifact", "component", "product", "cloud", "user-data"]).nullable(),
        parentResourceTypes: z.array(z.coerce.number()).nullable(),
        permissions: z.array(z.string()).nullable(),
        resourceTypeUri: z.string().nullable(),
        archiveDate: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/reMa/resource-types/:resourceTypeName
export const ArchiveResourceTypeRegistry = {
  requestSchema: z.object({
    params: z.object({
      resourceTypeName: z.string(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// POST /api/:version/reMa/roles
export const UpsertRoleRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      roleNumber: z.coerce.number().nullish(),
      roleName: z.string(),
      roleDescription: z.string(),
      roleType: z.enum(["user", "workload"]),
      namespace: z.enum(["cnx", "frg"]),
      organization: z.string(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      role: z.object({
        roleNumber: z.coerce.number(),
        roleName: z.string(),
        roleDescription: z.string().nullable(),
        roleType: z.enum(["user", "workload"]).nullable(),
        namespace: z.enum(["cnx", "frg"]).nullable(),
        organization: z.string().nullable(),
        roleUri: z.string().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/reMa/roles
export const GetRolesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      roles: z.array(z.object({
        roleNumber: z.coerce.number(),
        roleName: z.string(),
        roleDescription: z.string().nullable(),
        roleType: z.enum(["user", "workload"]).nullable(),
        namespace: z.enum(["cnx", "frg"]).nullable(),
        organization: z.string().nullable(),
        roleUri: z.string().nullable(),
      })),
    }),
  }),
};

// POST /api/:version/reMa/policies
export const UpsertPolicyRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      policyNumber: z.coerce.number().nullish(),
      policyUri: z.string(),
      version: z.string(),
      role: z.string(),
      allow: z.array(z.string()),
      deny: z.array(z.string()),
      resourceInstances: z.array(z.string()).nullish(),
      conditions: z.object({}).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      policy: z.object({
        policyNumber: z.coerce.number(),
        policyUri: z.string(),
        version: z.string().nullable(),
        role: z.string().nullable(),
        allow: z.array(z.string()).nullable(),
        deny: z.array(z.string()).nullable(),
        resourceInstances: z.array(z.string()).nullable(),
        conditions: z.object({}).nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/reMa/policies
export const GetPoliciesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      policies: z.array(z.object({
        policyNumber: z.coerce.number(),
        policyUri: z.string(),
        version: z.string().nullable(),
        role: z.string().nullable(),
        allow: z.array(z.string()).nullable(),
        deny: z.array(z.string()).nullable(),
        resourceInstances: z.array(z.string()).nullable(),
        conditions: z.object({}).nullable(),
      })),
    }),
  }),
};

// POST /api/:version/reMa/resource-instances
export const UpsertResourceInstanceRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      instanceNumber: z.coerce.number().nullish(),
      namespace: z.enum(["cnx", "frg"]),
      tenantId: z.coerce.number(),
      resourceCategory: z.string(),
      resourceTypeNumber: z.coerce.number(),
      parentInstancePaths: z.array(z.object({
        resourceType: z.string().nullish(),
        instanceId: z.string().nullish(),
      })).nullish(),
      resourceInstanceName: z.string(),
      resourceInstanceDescription: z.string(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      resourceInstance: z.object({
        instanceNumber: z.coerce.number(),
        resourceInstanceName: z.string(),
        resourceInstanceDescription: z.string().nullable(),
        resourceTypeNumber: z.coerce.number(),
        namespace: z.string().nullable(),
        tenantId: z.coerce.number().nullable(),
        resourceCategory: z.string().nullable(),
        parentInstancePaths: z.array(z.object({
          resourceType: z.string().nullable(),
          instanceId: z.string().nullable(),
        })).nullable(),
        instanceUri: z.string(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/reMa/resource-instances
export const GetResourceInstancesRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      resourceInstances: z.array(z.object({
        instanceNumber: z.coerce.number(),
        resourceInstanceName: z.string(),
        resourceInstanceDescription: z.string().nullable(),
        resourceTypeNumber: z.coerce.number(),
        namespace: z.string().nullable(),
        tenantId: z.coerce.number().nullable(),
        resourceCategory: z.string().nullable(),
        parentInstancePaths: z.array(z.object({
          resourceType: z.string().nullable(),
          instanceId: z.string().nullable(),
        })).nullable(),
        instanceUri: z.string(),
      })),
    }),
  }),
};

// GET /api/:version/sensenet/stations/:stationNumber/live-devices
export const GetLiveDevicesByStationNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      stationNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      devices: z.array(z.object({
        liveDeviceNumber: z.coerce.number().nullable(),
        deviceNumber: z.coerce.number(),
        stationNumber: z.coerce.number(),
        installDate: z.coerce.number(),
        uninstallDate: z.coerce.number().nullable(),
        installerUserId: z.string().uuid().nullable(),
        uninstallerUserId: z.string().uuid().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      })),
    }),
  }),
};

// POST /api/:version/sensenet/live-devices
export const UpsertLiveDeviceRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({}).default({}),
    body: z.object({
      deviceNumber: z.coerce.number(),
      stationNumber: z.coerce.number(),
      installDate: z.coerce.number(),
      uninstallDate: z.coerce.number().nullish(),
      installerUserId: z.string().uuid().nullish(),
      uninstallerUserId: z.string().uuid().nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      device: z.object({
        liveDeviceNumber: z.coerce.number().nullable(),
        deviceNumber: z.coerce.number(),
        stationNumber: z.coerce.number(),
        installDate: z.coerce.number(),
        uninstallDate: z.coerce.number().nullable(),
        installerUserId: z.string().uuid().nullable(),
        uninstallerUserId: z.string().uuid().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
      operation: z.enum(["created", "updated"]),
    }),
  }),
};

// GET /api/:version/sensenet/live-devices/:liveDeviceNumber
export const GetLiveDeviceByNumberRegistry = {
  requestSchema: z.object({
    params: z.object({
      liveDeviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      device: z.object({
        liveDeviceNumber: z.coerce.number().nullable(),
        deviceNumber: z.coerce.number(),
        stationNumber: z.coerce.number(),
        installDate: z.coerce.number(),
        uninstallDate: z.coerce.number().nullable(),
        installerUserId: z.string().uuid().nullable(),
        uninstallerUserId: z.string().uuid().nullable(),
        archiveDate: z.coerce.number().nullable(),
        createdAt: z.coerce.number().nullable(),
        updatedAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// DELETE /api/:version/sensenet/live-devices/:liveDeviceNumber
export const ArchiveLiveDeviceRegistry = {
  requestSchema: z.object({
    params: z.object({
      liveDeviceNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      archived: z.boolean(),
    }),
  }),
};

// GET /api/:version/uniq/farmgrid/users
export const GetFarmgridUsersRegistry = {
  requestSchema: z.object({
    params: z.object({}),
    query: z.object({
      page: z.coerce.number().nullish(),
      limit: z.coerce.number().nullish(),
    }).passthrough().default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      users: z.array(z.object({
        userNumber: z.coerce.number(),
        firstName: z.string(),
        lastName: z.string(),
        userInitials: z.string(),
        emailAddress: z.string(),
        userName: z.string(),
        userStatus: z.enum(["active", "suspended", "archived"]),
        createdAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        profilePicture: z.string().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        lastLoginAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        jobRoles: z.array(z.object({
          roleNumber: z.coerce.number(),
          roleName: z.string(),
        })).nullable(),
      })),
      pagination: z.object({
        total: z.coerce.number(),
        page: z.coerce.number(),
        limit: z.coerce.number(),
        hasMore: z.boolean(),
      }),
    }),
  }),
};

// GET /api/:version/uniq/farmgrid/users/:userNumber
export const GetFarmgridUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number(),
        firstName: z.string(),
        lastName: z.string(),
        userInitials: z.string(),
        emailAddress: z.string(),
        userName: z.string(),
        userStatus: z.enum(["active", "suspended", "archived"]),
        createdAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        profilePicture: z.string().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        lastLoginAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        jobRoles: z.array(z.object({
          roleNumber: z.coerce.number(),
          roleName: z.string(),
        })).nullable(),
      }),
    }),
  }),
};

// PATCH /api/:version/uniq/farmgrid/users/:userNumber
export const UpdateFarmgridUserRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({
      firstName: z.string().min(1).max(20).nullish(),
      lastName: z.string().min(1).max(20).nullish(),
      profilePicture: z.string().max(2048).nullish(),
      mobileNumber: z.string().min(10).max(10).nullish(),
      countryCode: z.string().min(1).max(3).nullish(),
    }),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      user: z.object({
        userNumber: z.coerce.number(),
        firstName: z.string(),
        lastName: z.string(),
        userInitials: z.string(),
        emailAddress: z.string(),
        userName: z.string(),
        userStatus: z.enum(["active", "suspended", "archived"]),
        createdAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        accounts: z.array(z.object({
          accountNumber: z.coerce.number(),
          name: z.string(),
          roleNumber: z.coerce.number(),
        })),
        profilePicture: z.string().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
        lastLoginAt: z.coerce.number().nullable(),
        archiveDate: z.coerce.number().nullable(),
        jobRoles: z.array(z.object({
          roleNumber: z.coerce.number(),
          roleName: z.string(),
        })).nullable(),
      }),
    }),
  }),
};

// GET /api/:version/uniq/farmgrid/users/:userNumber/profile
export const GetFarmgridUserProfileRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      profile: z.object({
        firstName: z.string(),
        lastName: z.string(),
        userInitials: z.string(),
        emailAddress: z.string(),
        userName: z.string(),
        userStatus: z.enum(["active", "suspended", "archived"]),
        profilePicture: z.string().nullable(),
        mobileNumber: z.string().nullable(),
        countryCode: z.string().nullable(),
      }),
    }),
  }),
};

// GET /api/:version/uniq/farmgrid/users/:userNumber/activity
export const GetFarmgridUserActivityRegistry = {
  requestSchema: z.object({
    params: z.object({
      userNumber: z.coerce.number(),
    }),
    query: z.object({}).default({}),
    body: z.object({}),
  }),
  responseSchema: z.object({
    message: z.string(),
    content: z.object({
      activity: z.object({
        createdAt: z.coerce.number(),
        updatedAt: z.coerce.number(),
        lastLoginAt: z.coerce.number().nullable(),
      }),
    }),
  }),
};

// Collection export — registry lookup for middleware and runtime validation
export const allSchemas = { HelloRegistry, HelloError500Schema, GetConexApiSpecRegistry, GetConexApiSpecError500Schema, UpsertUserRegistry, GetUsersRegistry, GetUserByNumberRegistry, GetUserByNumberError404Schema, ArchiveUserRegistry, SetUserStatusRegistry, FetchUserProfilePictureRegistry, GetUserEventTimelineRegistry, GetUserByEmailRegistry, GetUserByEmailError404Schema, ResendUserInvitationRegistry, GetHumanUserRolesRegistry, GenerateEntraOauthTokenRegistry, LoginRegistry, LoginError401Schema, LoginError403Schema, LoginError500Schema, FarmgridUserLoginRegistry, FarmgridUserLoginError401Schema, FarmgridUserLoginError403Schema, FarmgridUserLoginError500Schema, SilentRefreshRegistry, SilentRefreshError401Schema, SilentRefreshError404Schema, SilentRefreshError500Schema, GetCurrentUserRegistry, GetCurrentUserError401Schema, GetCurrentUserError500Schema, LogoutRegistry, LogoutError401Schema, LogoutError404Schema, LogoutError500Schema, ValidateSessionRegistry, ValidateSessionError401Schema, ValidateSessionError500Schema, GetAwsTempCredentialsRegistry, GetAwsTempCredentialsError400Schema, GetAwsTempCredentialsError500Schema, GetAwsPresignedUrlRegistry, GetAwsPresignedUrlError400Schema, GetAwsPresignedUrlError500Schema, UpsertContractRegistry, GetContractByContractNumberRegistry, ArchiveContractRegistry, UpsertOrganizationRegistry, GetOrganizationsRegistry, ResolveOrganizationsRegistry, ResolveOrganizationsError400Schema, ResolveOrganizationsError500Schema, GetOrganizationByNumberRegistry, ArchiveOrganizationRegistry, UnarchiveOrganizationRegistry, GetOrganizationMembershipsRegistry, UpsertOrganizationMembershipRegistry, ArchiveOrganizationMembershipRegistry, GetMembershipsRegistry, GetOrganizationFarmgridAccountRegistry, UpdateOrganizationFarmgridAccountRegistry, UpsertOrganizationAddressRegistry, GetAddressesByOrgNumberRegistry, UpsertStationRegistry, GetStationsRegistry, GetStationByNumberRegistry, DeleteStationRegistry, UpdateSiteCoverageRegistry, GetSiteCoverageForStationRegistry, UpsertSiteCoverageRegistry, GetSiteCoverageByKeysRegistry, ArchiveSiteCoverageRegistry, UpsertNetworkSiteRegistry, GetNetworkSitesRegistry, GetNetworkSiteByNumberRegistry, DeleteNetworkSiteRegistry, UpsertNetworkCorridorRegistry, GetNetworkCorridorsRegistry, GetNetworkCorridorByNumberRegistry, DeleteNetworkCorridorRegistry, GetNetworkCorridorPartnersRegistry, UpdateNetworkCorridorPartnersRegistry, UpsertDeviceRegistry, GetDevicesRegistry, GetDeviceByNumberRegistry, ArchiveDeviceRegistry, UpsertDeviceProcurementInfoRegistry, UpsertDeviceProvisioningInfoRegistry, UpsertDeviceRetirementInfoRegistry, UpsertDeviceFaultInfoRegistry, GetAddressListForDeviceProcurementRegistry, UpsertDeviceProfileRegistry, GetDeviceProfilesRegistry, GetDeviceProfileRegistry, ArchiveDeviceProfileRegistry, UpsertDeviceKeyInfoRegistry, GetDeviceKeyInfoRegistry, ArchiveDeviceKeyInfoRegistry, UpsertDeviceManufacturerRegistry, GetDeviceManufacturersRegistry, GetDeviceManufacturerRegistry, ArchiveDeviceManufacturerRegistry, UpsertDeviceDistributorRegistry, GetDeviceDistributorsRegistry, GetDeviceDistributorRegistry, ArchiveDeviceDistributorRegistry, UpsertDeviceTypeRegistry, GetDeviceTypesRegistry, GetDeviceTypeRegistry, ArchiveDeviceTypeRegistry, UpsertFetchTypeRegistry, GetFetchTypesRegistry, GetFetchTypeRegistry, ArchiveFetchTypeRegistry, CreateFetchInstancesRegistry, GetFetchInstancesRegistry, GetFetchInstanceRegistry, UpdateFetchInstanceStatusRegistry, MailChimpSubscribeRegistry, UpsertInvitationRegistry, GetInvitationListRegistry, AcceptInvitationRegistry, AcceptInvitationByEmailRegistry, DeclineInvitationRegistry, RevokeInvitationRegistry, ResendInvitationRegistry, GetInvitationTypesRegistry, UpsertInvitationTypeRegistry, GetInvitationTypeRegistry, ArchiveInvitationTypeRegistry, CreateJobRoleRegistry, GetJobRolesRegistry, UpdateJobRoleRegistry, GetJobRoleByNumberRegistry, ArchiveJobRoleRegistry, UpsertJobRoleToUserRegistry, RemoveJobRoleFromUserRegistry, GetOrganizationsForUserRegistry, UpsertOrganizationToUserRegistry, RemoveOrganizationFromUserRegistry, RemoveOrganizationFromUserError400Schema, GetUsersForOrganizationRegistry, UpsertResourceTypeRegistry, GetResourceTypesRegistry, GetResourceTypeByNameRegistry, ArchiveResourceTypeRegistry, UpsertRoleRegistry, GetRolesRegistry, UpsertPolicyRegistry, GetPoliciesRegistry, UpsertResourceInstanceRegistry, GetResourceInstancesRegistry, GetLiveDevicesByStationNumberRegistry, UpsertLiveDeviceRegistry, GetLiveDeviceByNumberRegistry, ArchiveLiveDeviceRegistry, GetFarmgridUsersRegistry, GetFarmgridUserRegistry, UpdateFarmgridUserRegistry, GetFarmgridUserProfileRegistry, GetFarmgridUserActivityRegistry };
